<div class="role-assignment-dialog">
  <hr class="mt-0" />
  <form [formGroup]="roleAssignmentForm" (ngSubmit)="onSave()" class="form-container">
    <!-- Form Fields Grid -->
    <div class="form-grid flex gap-4">
      <!-- User Selection - Hidden when editing a specific user -->
      <div class="field flex-1 mb-2" *ngIf="!isEditMode || !preSelectedUser">
        <label for="user-select"
          >{{ 'layout.configurations.users.assignRolesToUser.selectUser' | translate
          }}<span class="required">*</span></label
        >
        <p-dropdown
          id="user-select"
          formControlName="selectedUser"
          [options]="users"
          optionLabel="name"
          dataKey="id"
          [placeholder]="'layout.configurations.users.assignRolesToUser.chooseUser' | translate"
          [showClear]="false"
          [filter]="true"
          filterBy="name,email"
          [filterPlaceholder]="'layout.configurations.users.assignRolesToUser.searchUsers' | translate">
          <ng-template pTemplate="selectedItem" let-user>
            <div class="flex items-center gap-2" *ngIf="user">
              <img
                [src]="user.photo"
                [alt]="user.name"
                class="w-6 h-6 rounded-full object-cover"
                style="width: 24px !important; height: 24px !important;"
                (error)="onImageError($event, user.name)"
              />
              <span class="font-medium">{{ user.name }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-user>
            <div class="flex items-center gap-2">
              <img
                [src]="user.photo"
                [alt]="user.name"
                class="w-6 h-6 rounded-full object-cover"
                style="width: 24px !important; height: 24px !important;"
                (error)="onImageError($event, user.name)"
              />
              <span class="font-medium">{{ user.name }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- User Info Display - Shown when editing a specific user -->
      <div class="field flex-1 mb-2" *ngIf="isEditMode && preSelectedUser">
        <label>{{ 'layout.configurations.users.assignRolesToUser.editingRolesFor' | translate
          }}</label>
        <div class="user-info-display p-3 border-1 border-300 border-round bg-gray-50 match-role-width">
          <div class="flex items-center gap-2">
            <img
              [src]="preSelectedUser.photo"
              [alt]="preSelectedUser.name"
              class="w-8 h-8 rounded-full object-cover"
              style="width: 32px !important; height: 32px !important;"
              (error)="onImageError($event, preSelectedUser.name)"
            />
            <div>
              <div class="font-semibold">{{ preSelectedUser.name }}</div>
              <div class="text-sm text-500">{{ preSelectedUser.email }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Role Selection -->
      <div class="field flex-1 mb-2">
        <label for="role-select">
          {{
            editingSingleRole
              ? ('layout.configurations.users.assignRolesToUser.selectRole' | translate)
              : ('layout.configurations.users.assignRolesToUser.selectRoles' | translate)
          }}
          <span class="required">*</span>
        </label>

        <!-- Single Role Selection for editing individual assignments -->
        <div *ngIf="editingSingleRole">
          <p-dropdown
            id="role-select"
            [options]="roles"
            optionLabel="name"
            [placeholder]="'layout.configurations.users.assignRolesToUser.chooseRole' | translate"
            [(ngModel)]="selectedSingleRole"
            (onChange)="onSingleRoleChange($event)"
            [showClear]="false">
            <ng-template pTemplate="item" let-role>
              <span class="font-medium">{{ role.name }}</span>
            </ng-template>
          </p-dropdown>
        </div>

        <!-- Multiple Role Selection for bulk assignment -->
        <p-multiSelect
          *ngIf="!editingSingleRole"
          id="role-select"
          formControlName="selectedRoles"
          [options]="roles"
          optionLabel="name"
          [placeholder]="'layout.configurations.users.assignRolesToUser.chooseRoles' | translate"
          [scrollHeight]="'220px'"
          [showToggleAll]="true"
          [filter]="true"
          filterBy="name"
          [filterPlaceHolder]="'layout.configurations.users.assignRolesToUser.searchRoles' | translate"
          [resetFilterOnHide]="false"
          [appendTo]="'body'"
          
          (onChange)="onMultiRoleChange($event)">
          <ng-template pTemplate="item" let-role>
            <span class="font-medium">{{ role.name }}</span>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>

    <hr />
    <!-- Action Buttons -->
    <div class="form-actions">
      <p-button
        type="submit"
        [label]="isEditMode ? ('layout.configurations.users.assignRolesToUser.update' | translate) : ('layout.configurations.users.assignRolesToUser.save' | translate)"
        severity="success"
        icon="pi pi-check">
      </p-button>
    </div>
  </form>
</div>